import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "../../components/ui/button";
import { toast } from "react-toastify";
import { Search } from "lucide-react";

const ITEMS_PER_PAGE = 8;

const ExamenesPage = () => {
  const [examenes, setExamenes] = useState([]);
  const [filteredExamenes, setFilteredExamenes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const token = localStorage.getItem("token");
  const API_URL = process.env.REACT_APP_API_URL + "/util";

  const fetchExamenes = async () => {
    try {
      const res = await axios.get(`${API_URL}/examenes`, { headers: { Authorization: `Bearer ${token}` } });
      setExamenes(res.data);
      setFilteredExamenes(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Error al obtener exámenes");
    }
  };

  useEffect(() => { fetchExamenes(); }, []); // eslint-disable-line

  useEffect(() => {
    const lower = searchTerm.toLowerCase();
    setFilteredExamenes(examenes.filter((e) =>
      (e.examen_cod || "").toLowerCase().includes(lower) || (e.nombre || "").toLowerCase().includes(lower)
    ));
    setCurrentPage(1);
  }, [searchTerm, examenes]);

  const totalPages = Math.ceil(filteredExamenes.length / ITEMS_PER_PAGE);
  const currentExamenes = filteredExamenes.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <div className="relative w-full sm:w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-brand-400" />
          <input
            type="text"
            placeholder="Buscar examen..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-9 pr-4 border border-brand-200 rounded-xl py-2 text-sm bg-brand-50 focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100"
          />
        </div>
      </div>

      <div className="overflow-x-auto rounded-xl border border-brand-100">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-brand-gradient text-white">
              {["Código", "Nombre"].map((h) => (
                <th key={h} className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-50">
            {currentExamenes.length > 0 ? currentExamenes.map((e, i) => (
              <tr key={e._id || e.examen_cod} className={`transition-colors ${i % 2 === 0 ? "bg-white" : "bg-brand-50/30"} hover:bg-brand-50`}>
                <td className="px-4 py-3">
                  <span className="font-mono text-xs bg-brand-100 text-brand-700 px-2 py-0.5 rounded font-semibold">{e.examen_cod}</span>
                </td>
                <td className="px-4 py-3 text-gray-800 font-medium">{e.nombre}</td>
              </tr>
            )) : (
              <tr><td colSpan="2" className="py-8 text-center text-gray-400 italic text-sm">No se encontraron exámenes.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="flex justify-between items-center text-sm text-gray-600">
          <span>{currentExamenes.length} de {filteredExamenes.length}</span>
          <div className="flex gap-2">
            <Button variant="outline" size="sm" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>← Anterior</Button>
            <span className="px-3 py-1.5 bg-brand-50 border border-brand-200 rounded-lg text-brand-700 font-medium">{currentPage}/{totalPages}</span>
            <Button variant="outline" size="sm" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>Siguiente →</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExamenesPage;
